import React from "react";
import styled from "styled-components";

const OmronFooter: React.FC = () => (
  <Footer>
    <div>&copy; 2022 OMRON Corporation.</div>
  </Footer>
);

export default OmronFooter;

// style

const Footer = styled.footer`
  grid-area: footer;
  padding: 1rem 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  font-weight: normal;
  color: #999999;
  background: #fafafa;
`;
